<template>
<m-pageframe
    title="Engagement: Bulk Messages"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

     <v-layout row wrap style="margin-bottom: 5px">
        <v-flex flex-grow-0>
            <m-boolean-search-filter
                style="margin-top: 5px; margin-left: 10px;"
                label="Archived"
                v-model="filter_archived"
                v-on:input='doUpdate'
            />
        </v-flex>
        <v-flex flex-grow-0>
            <m-boolean-search-filter
                style="margin-top: 5px; margin-left: 10px;"
                    label="Revenue Account"
                    v-model="filter_revenue"
                    v-on:input='doUpdate'
                />    
        </v-flex>
     </v-layout>

     
    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="10000"
        class="elevation-1"
        :hide-default-footer="true"
        
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.some_field="{ item }">
            {{item.some_field}}
        </template>
    
    </v-data-table>

    <div
        style="margin-top: 15px; font-size: 12px"
    >
        Engagements statistics are updated each morning at 3:00 AM America/Phoenix time.
    </div>


</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Organization', value: 'organization_label'},
                { text: 'Industry', value: 'organization_industry'},
                { text: 'Created', value: 'organization_create_date'},
                { text: 'Created (days)', value: 'organization_days_since_create_date'},

                { text: 'Messages (30 days)', value: 'bulk_message_sent_count_last_30'},
                { text: 'Messages (60 days)', value: 'bulk_message_sent_count_last_60'},
                { text: 'Messages (90 days)', value: 'bulk_message_sent_count_last_90'},
                { text: 'Messages (All Time)', value: 'bulk_message_sent_count_all_time'},

                { text: 'Recipients (30 days)', value: 'bulk_message_recipient_count_last_30'},
                { text: 'Recipients (60 days)', value: 'bulk_message_recipient_count_last_60'},
                { text: 'Recipients (90 days)', value: 'bulk_message_recipient_count_last_90'},
                { text: 'Recipients (All Time)', value: 'bulk_message_recipient_count_all_time'},
            ],

            filter_archived: false,
            filter_revenue: true,
        }
    },    

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/admin/usage/bulk-messages',
            
                'params' : {
                        'full_text': this.full_text,
                        'organization_is_archived': this.filter_archived,
                        'organization_is_revenue_account': this.filter_revenue,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to search bulk message engagement',
            });
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>